import { cn } from 'cn';
import type { DetailsHTMLAttributes, HTMLAttributes, ReactNode } from 'react';

export interface DetailsProps {
  variant: 'simple' | 'customizedSummary';
  children: ReactNode;
  SummaryComponent?: ReactNode;
  CollapseDetailsComponent?: ReactNode;
  ExpandDetailsComponent?: ReactNode;
  detailsProps?: { open?: boolean } & DetailsHTMLAttributes<HTMLDetailsElement>;
  summaryComponentProps?: HTMLAttributes<HTMLElement> & { 'data-testid'?: string };
  className?: string;
}

export function Details({
  variant,
  children,
  SummaryComponent,
  CollapseDetailsComponent,
  ExpandDetailsComponent,
  detailsProps,
  summaryComponentProps,
  className,
}: DetailsProps) {
  const { className: summaryClassName, ...restSummaryComponentProps } = summaryComponentProps ?? {};

  return (
    <details className={cn('group', className)} {...detailsProps}>
      <summary
        className={cn(
          'flex cursor-pointer list-none items-center gap-1 focus-visible:focus-ring',
          summaryClassName,
        )}
        {...restSummaryComponentProps}
      >
        {variant === 'simple' ? (
          SummaryComponent
        ) : (
          <>
            <span className="group-open:hidden">{ExpandDetailsComponent}</span>
            <span className="hidden group-open:inline">{CollapseDetailsComponent}</span>
          </>
        )}
      </summary>
      {children}
    </details>
  );
}
